import axios from 'axios'
import qs from 'qs'

const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
  setTimeout(() => reject(TIMEOUT), 10e3)

export default {
  // 应用列表
  getAppList (params) {
    const url = '/dashboard/app/list?currPage=' + params.currPage + '&keyword=' + params.keyword + '&type=' + params.type + '&pageSize=10'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  getDefaultApp () {
    const url = '/dashboard/app/default'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  setDefaultApp (appId) {
    const url = '/dashboard/app/set-default?appId=' + appId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取某个应用的服务列表
  getServices (params) {
    const url = '/dashboard/app/services?appId=' + params.appId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 为某个应用添加服务
  addService (params, isNew) {
    const url = isNew ? '/dashboard/webapi/addService/v1' : '/dashboard/app/service/add'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 查询某个服务的服务量
  getServiceNum (params) {
    const url = '/dashboard/app/service-num-list'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 查询所有服务的数据统计
  getServiceCount (params) {
    const url = '/dashboard/opendata/statistic'
    // const url = '/dashboard/app/service-num-list'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 导出统计数据
  exportExcel (params) {
    const url = '/dashboard/opendata/exportExcel'
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: qs.stringify(params),
        responseType: 'blob'
      }).then(res => resolve(res.data))
      timeout(reject)
    })
  },
  getWebApiInfo (appId, businessId) {
    const url = '/dashboard/app/webapi/getInfo?appId=' + appId + '&channel=' + businessId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  updateWebApiIpList (params) {
    const url = '/dashboard/app/webapi/updateWebApiIpList'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 新的开通流程，保存ip白名单
  newUpdateWebApiIpList (params) {
    const url = '/dashboard/webapi/updateWhitelist/v1'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 领取用户等级权益
  customerLevelRight(params) {
    const url = '/dashboard/level/use'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 领取会员权益
  getUserBenefit(params) {
    const url = '/dashboard/vip/getUserBenefit'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 检查用户已领取的权益
  checkUserBenefit() {
    const url = '/dashboard/vip/checkUserBenefit'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
      timeout(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./app/api/my-app.js